module.exports = "<div class=\"text-center\">\r\n<button type=\"button\" (click)=\"onClick('onEdit')\" class=\"btn btn-sm btn-info\"><i class=\"fa fa-edit\" aria-hidden=\"true\"></i></button>\r\n<button type=\"button\" (click)=\"onClick('onDelete')\" class=\"btn btn-sm btn-danger\" style=\"color:#fff\"><i class=\"fa fa-trash\" aria-hidden=\"true\"></i></button>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/shared/components/smart-table/action-buttons/action-buttons.component.html
// module id = ../../../../../src/app/shared/components/smart-table/action-buttons/action-buttons.component.html
// module chunks = main